/**
 * @module 日期组件标准下拉项组件
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import DropdownList from '../DropdownList';

function DatePickerDropdownList(_ref) {
  var className = _ref.className,
      width = _ref.width,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(DropdownList, {
    className: classNames('jmtd-date-picker-panel', className),
    width: width
  }, children);
}

DatePickerDropdownList.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node
};
DatePickerDropdownList.defaultProps = {
  className: '',
  width: 270,
  children: null
};
export default DatePickerDropdownList;